import Control from "ol/control/Control";
export class Toolbar extends Control {
    constructor(opt_options) {
        const elem = document.createElement('div');
        elem.className = 'toolBar ol-unselectable ol-control';
        opt_options.element = elem;
        super(opt_options);
        this.ui = $(elem);
        this.buttons = opt_options.buttons || [];
        this.initialize_ui();
    }
    initialize_ui() {
        for (let button of this.buttons) {
            this.ui.append(button.ui);
        }
    }
    add_buttons(...buttons) {
        for (let btn of buttons) {
            this.buttons.push(btn);
            this.ui.append(btn.ui);
        }
    }
}
